var render = function render(_c,_vm){return _c('div',{staticClass:"tire-recommendation-sidebar-import-error",attrs:{"role":"alert"}},[_vm._v("Could not load the tire recommender.")])
}
var staticRenderFns = []

export { render, staticRenderFns }